import { ApolloProvider } from "@apollo/client";
import { Applications } from "@biggeo/bg-server-lib/studio";
import {
    CssBaseline,
    ThemeProvider as LegacyThemeProvider,
    LicenseInfo,
} from "@biggeo/bg-ui";
import { ThemeProvider } from "@biggeo/bg-ui/lab";
import { theme } from "@biggeo/bg-ui/lab/theme";
import { theme as legacyTheme } from "@biggeo/bg-ui/theme";
import LogRocket from "logrocket";
import { Provider } from "react-redux";
import Routes from "./Routes";
import { GoogleTagManager } from "./components/GoogleTagManager";
import { getSplitLink } from "./map/utils/subscription";
import "json-bigint-patch";
import store from "./redux/store";
import ToastContainer from "./toaster/containers/ToastContainer";
import { clientGenerator } from "@biggeo/bg-common";
import {
    appEnvFromEnv,
    xgridKeyFromEnv,
    logRocketIDFromEnv,
} from "./config/env.config";

const DATASCAPE_LOG_ROCKET_ID = logRocketIDFromEnv();
if (!!DATASCAPE_LOG_ROCKET_ID && typeof window !== "undefined") {

    /**
     * This ensures that LogRocket is only initialized in the browser environment
     * and not during server-side rendering (SSR) or static site generation (SSG).
     * Attempting to initialize browser-specific APIs like LogRocket on the server will lead to errors.
     */
    LogRocket.init(DATASCAPE_LOG_ROCKET_ID);
}

export const XGRID_API_KEY = xgridKeyFromEnv();

LicenseInfo.setLicenseKey(XGRID_API_KEY);

const App = () => {
    const apolloClient = clientGenerator({
        headers: {},
        app: Applications.datascape,
        getLink: getSplitLink,
    });

    return (
        <ApolloProvider client={apolloClient}>
            <LegacyThemeProvider theme={legacyTheme}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Provider store={store}>
                        <GoogleTagManager />
                        <Routes />
                        <ToastContainer />
                    </Provider>
                </ThemeProvider>
            </LegacyThemeProvider>
        </ApolloProvider>
    );
};

export default App;
